export const MARK_STEP_COMPLETE = 'mark_step_complete';
export const MARK_STEP_INCOMPLETE = 'mark_step_incomplete';
export const MARK_STEP_VISITED = 'mark_step_visited';
export const SET_TRANSITIONING = 'set_transitioning';
